<template>
  <div class="share-page">
    <!-- 头部导航 -->
    <el-header class="custom-navbar" style="border-bottom: 1px solid #f5f5f5">
      <div class="nav-content">
        <div class="nav-left">
          <el-button icon="el-icon-back" plain @click="back">返回</el-button>
        </div>
        <div class="nav-title">朋友圈分享</div>
        <div class="nav-right">
          <el-button type="text" @click="saveDraft" v-if="showEdit">保存草稿</el-button>
        </div>
      </div>
    </el-header>

    <!-- 主内容区 -->
    <el-main class="main-content">
      <!-- 编辑区域 -->
      <div v-if="showEdit" class="edit-container">
        <!-- 文案输入区 -->
        <el-card class="input-card">
          <div slot="header" class="card-header">
            <span class="card-title">分享文案</span>
            <span class="card-tip">写出此刻的心情</span>
          </div>
          <el-input
              type="textarea"
              v-model="editText"
              placeholder="这一刻的想法..."
              maxlength="500"
              show-word-limit
              :rows="6"
              class="content-input"
              ref="textArea"
          />
          <div class="input-footer">
            <span class="char-count">{{ editText.length }}/500</span>
            <el-button icon="el-icon-smile" plain @click="showEmojiDialog = true">
              表情
            </el-button>
          </div>
        </el-card>

        <!-- 图片上传区 -->
        <el-card class="upload-card">
          <div slot="header" class="card-header">
            <span class="card-title">添加图片</span>
            <span class="card-tip">最多可选9张</span>
          </div>
          <el-upload
              class="image-uploader"
              action="#"
              :auto-upload="false"
              :file-list="fileList"
              :on-change="handleImageChange"
              :on-remove="handleImageRemove"
              :limit="9"
              list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- 图片预览弹窗 -->
          <el-dialog
              v-if="previewVisible"
              :visible.sync="previewVisible"
              title="图片预览"
              width="80%"
          >
            <img
                :src="previewImage"
                alt="预览图片"
                style="width: 100%;"
            />
          </el-dialog>
          <div class="upload-tips">
            <div class="tip-item">
              <i class="el-icon-info"></i>
              建议上传清晰图片
            </div>
            <div class="tip-item">
              <i class="el-icon-info"></i>
              支持从相册选择图片
            </div>
          </div>
        </el-card>

        <!-- 高级选项 -->
        <el-card class="options-card">
          <div slot="header" class="card-header">
            <span class="card-title">高级选项</span>
          </div>
          <el-form :model="advancedOptions" class="option-form">



              <el-form-item label="分类">
                <el-select v-model="advancedOptions.cate_id" style="width: 200px;" placeholder="请选择分类"  @change="handleIsopenSelect">
                  <el-option :key="item.id"  v-for="item in cateMenus" :label="item.pid>0?'|--'+item.name:item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>


            <el-form-item label="添加位置">
              <el-input
                  v-model="advancedOptions.location"
                  placeholder="未选择"
                  readonly
                  @click="selectLocation"
                  class="option-input"
              />
            </el-form-item>
            <el-form-item label="谁可以看">
              <el-select
                  v-model="advancedOptions.privacy"
                  placeholder="公开"
                  class="option-select"
              >
                <el-option label="公开" value="public"></el-option>
                <el-option label="私密" value="private"></el-option>
                <el-option label="仅朋友可见" value="friends"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提醒谁看">
              <el-input
                  v-model="remindText"
                  placeholder="未选择"
                  readonly
                  @click="selectRemind"
                  class="option-input"
              />
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <!-- 预览区域 -->
      <div class="preview-container" v-else>
        <!-- 分享卡片预览 -->
        <el-card class="preview-card">
          <div class="share-card">
            <div class="user-info">
              <img :src="userInfo.avatar" alt="头像" class="avatar" />
              <span class="username">{{ userInfo.name }}</span>
            </div>
            <div class="share-content" v-if="contentText">
              {{ contentText }}
            </div>
            <div class="share-images" v-if="imageList.length">
              <img
                  v-for="(img, index) in imageList"
                  :key="index"
                  :src="img"
                  alt="分享图片"
                  class="preview-image"
                  @click="previewImageHandle(img)"
              />
            </div>
          </div>
        </el-card>

        <!-- 操作提示 -->
        <el-card class="preview-tips-card">
          <div class="preview-tips">
            <div class="tip-item">
              <i class="el-icon-info"></i>
              <span>右键图片可保存到本地</span>
            </div>
            <div class="tip-item">
              <i class="el-icon-info"></i>
              <span>复制文案后可直接粘贴到朋友圈</span>
            </div>
          </div>
        </el-card>

        <!-- 修改按钮 -->
        <el-button
            type="primary"
            icon="el-icon-edit"
            @click="generateShare"
            class="modify-btn"
        >
          重新编辑
        </el-button>
      </div>
    </el-main>

    <!-- 底部操作栏 -->
    <el-footer class="action-bar">
      <div class="action-left">
        <el-button icon="el-icon-delete" plain @click="clearAll">清空</el-button>
      </div>
      <div class="action-right">
        <el-button
            type="primary"
            icon="el-icon-share"
            @click="generateShare"
            class="generate-btn"
        >
          {{ showEdit ? '生成预览' : '返回编辑' }}
        </el-button>
      </div>
    </el-footer>

    <!-- 表情选择弹窗 -->
    <el-dialog
        title="选择表情"
        :visible.sync="showEmojiDialog"
        width="600px"
        top="5vh"
    >
      <div class="emoji-content">
        <span
            v-for="(emoji, index) in emojiList"
            :key="index"
            class="emoji-item"
            @click="insertEmojiText(emoji)"
        >
          {{ emoji }}
        </span>
      </div>
    </el-dialog>

    <!-- 位置选择弹窗 -->
    <el-dialog
        title="选择位置"
        :visible.sync="showLocationDialog"
        width="500px"
    >
      <el-input
          v-model="tempLocation"
          placeholder="输入位置名称"
          class="location-input"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="showLocationDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmLocation">确认</el-button>
      </div>
    </el-dialog>

    <!-- 提醒谁看弹窗 -->
    <el-dialog
        title="选择提醒的人"
        :visible.sync="showRemindDialog"
        width="500px"
    >
      <el-select
          v-model="selectedRemindUsers"
          multiple
          placeholder="选择联系人"
          class="remind-select"
      >
        <el-option
            v-for="user in remindUserList"
            :key="user.id"
            :label="user.name"
            :value="user.id"
        ></el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRemindDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmRemind">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import axios from 'axios'
export default {
  name: 'SharePage',
  data() {
    return {
      ruleForm:{
        id:''
      },
      cateMenus:[],

      // 核心数据
      contentText: '', // 预览文案
      editText: '', // 编辑文案
      imageList: [], // 图片列表（预览用）
      fileList: [], // 上传文件列表（Element Upload用）
      userInfo: {
        name: 'Web用户',
        avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132'
      },
      showEdit: true, // 是否显示编辑区
      showEmojiDialog: false, // 表情弹窗
      showLocationDialog: false, // 位置选择弹窗
      showRemindDialog: false, // 提醒谁看弹窗
      previewVisible: false, // 图片预览弹窗
      previewImage: '', // 预览图片地址
      tempLocation: '', // 临时位置
      selectedRemindUsers: [], // 选中的提醒用户ID
      remindUserList: [ // 模拟联系人列表
        { id: 1, name: '张三' },
        { id: 2, name: '李四' },
        { id: 3, name: '王五' },
        { id: 4, name: '赵六' }
      ],

      // 高级选项
      advancedOptions: {
        location: '',
        privacy: 'public',
        cate_id:''
      },

      // 表情列表
      emojiList: [
        '😊', '😂', '🥰', '😍', '🤩', '😎', '🤔', '🥳',
        '👍', '👏', '🙌', '🎉', '❤️', '🔥', '🌟', '✨',
        '💪', '👀', '💯', '✅', '📱', '📸', '🎈', '🍻',
        '🍕', '☕', '🎵', '🎮', '✈️', '🏖️', '🎁', '💰'
      ]
    }
  },
  computed: {
    // 提醒人数文本
    remindText() {
      return this.selectedRemindUsers.length
          ? `${this.selectedRemindUsers.length}人`
          : '未选择';
    }
  },
  mounted() {
    this.getCateMenus();
    var id= this.$route.query.id;
    if(!isNaN(id)&&id>0){
      this.ruleForm.id=id;
      this.getOne();
    }
    // 页面加载时加载草稿
    this.loadDraft();
    // 监听文本域光标（可选）
    this.initTextareaCursor();
  },
  methods: {
    getOne(){
      let _this=this;
      this.$axios.demandUploadsOne({
        access_token:sessionStorage.getItem('token'),
        company_id:sessionStorage.getItem('company_id'),
        id:_this.ruleForm.id
      }).then((res)=>{
        if(res.code==200){
          let item=res.data;
          _this.editText=item.title;

          _this.advancedOptions.cate_id=item.cate_id;
          // _this.ruleForm.cat_id= item.cat_id;
          // _this.ruleForm.istop= item.istop==1?true:false;
          // _this.ruleForm.recommond= item.recommond==1?true:false;
          // _this.ruleForm.content= item.content;
          // _this.ruleForm.video_url= item.video_url;
          // //_this.editor.txt.html(res.data.data.content);
          // _this.ruleForm.file_url=item.file_url;
          // _this.ruleForm.summary=item.summary;
          // //   _this.ruleForm.recommond=res.data.data.recommond==1?true:false;
          // //   _this.ruleForm.istop=res.data.data.istop==1?true:false;
          // //   _this.ruleForm.ishot=res.data.data.ishot==1?true:false;
         // _this.ruleForm.upload_time=item.upload_time>0?_this.dateFormat(item.upload_time*1000):'';
          //_this.ruleForm.url=item.link;
          if(item.uploads!=''&&item.uploads!=null&&item.uploads.length>0){
            item.uploads.map(function (rs){
              console.log('rs------4444---',rs)
              var img={
                name:1,
                url:rs.file_url
              }
              _this.fileList.push(img);
            })

          }

        }
        console.log(res);
      });
    },
    // 初始化文本域光标（用于表情插入）
    initTextareaCursor() {
      this.$refs.textArea.$el.addEventListener('click', () => {
        this.currentCursorPos = this.getCursorPosition();
      });
    },

    // 返回上一页（Web端模拟）
    back() {
      this.$router.go(-1);
      // this.$confirm('是否保存为草稿？', '提示', {
      //   confirmButtonText: '保存',
      //   cancelButtonText: '不保存',
      //   type: 'warning'
      // }).then(() => {
      //   this.saveDraft();
      //   this.$message({ type: 'success', message: '已返回并保存草稿' });
      //   // 实际项目中可替换为路由跳转：this.$router.go(-1)
      // }).catch(() => {
      //   this.$message({ type: 'info', message: '已返回未保存草稿' });
      //   // this.$router.go(-1)
      // });
    },
    getCateMenus(){
      let _this = this;
      let params={
        access_token:sessionStorage.getItem('token'),
        company_id:sessionStorage.getItem('company_id'),
      };
      this.$axios.demandCategoryTable(params).then((res)=>{
        if(res.code == 200) {
          _this.cateMenus=res.data;
        }
      });
    },
    // 保存草稿（替换uni.setStorageSync）
    saveDraft() {

      // 仅校验 未定义/空字符串/Null，允许 0 作为有效 cate_id
      if (this.advancedOptions.cate_id === undefined ||
          this.advancedOptions.cate_id === null ||
          this.advancedOptions.cate_id.toString().trim() === '') {
        this.$message({ type: 'error', message: '分类ID不能为空，请先选择分类！' });
        return;
      }
      const param = {
        title: this.editText,
        cate_id:this.advancedOptions.cate_id,
        images: this.imageList,
        location: this.advancedOptions.location,
        privacy: this.advancedOptions.privacy,
        remindUsers: this.selectedRemindUsers,
        time: Date.now(),
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      };
      if(this.fileList.length>0){
        param.uploads=this.fileList;
      }
      if(this.ruleForm.id){
        param.id=this.ruleForm.id;
      }

      this.$axios.demandSave(param).then(res=>{
        if(res.code==200){
          localStorage.setItem('shareDraft', JSON.stringify(param));
          this.$message({ type: 'success', message: '已保存到草稿' });
        }
      })

    },

    // 加载草稿
    loadDraft() {
      const draftStr = localStorage.getItem('shareDraft');
      if (draftStr) {
        const draft = JSON.parse(draftStr);
        this.editText = draft.text || '';
        this.imageList = draft.images || [];
        this.advancedOptions.location = draft.location || '';
        this.advancedOptions.privacy = draft.privacy || 'public';
        this.selectedRemindUsers = draft.remindUsers || [];

        // 同步文件列表（用于上传组件显示）
        this.fileList = this.imageList.map((url, index) => ({
          name: `image${index + 1}.jpg`,
          url: url
        }));
      }
    },

    // 图片上传改变事件
    // handleImageChange(file, fileList) {
    //   this.fileList = fileList;
    //   // 转换为预览URL
    //   this.imageList = fileList.map(item => {
    //     return item.url || URL.createObjectURL(item.raw);
    //   });
    // },
    async handleImageChange (item,fileList) {
      console.log(fileList)
      let _this=this;
      // let formData = new FormData()
      let file = item.raw;
      this.logoFile=item.raw;

      let file_md5, file_sha1;
      await this.calculateMD5(file).then(md5 => {
        file_md5 = md5;
        console.log('MD5:', md5)
      });
      await this.calculateSHA1(file).then(sha1 => {
        file_sha1 = sha1;
        console.log('SHA1:', sha1);
      });

      // 获取文件名
      const fileName = file.name;
      // 获取文件大小
      const fileSize = file.size;
      // 获取文件后缀
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

      console.log('文件名称：', fileName);
      console.log('文件后缀：', fileExtension);
      console.log('文件大小：', fileSize);
      let param_1 = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        md5: file_md5,
        sha1: file_sha1,
        size: fileSize
      };
      this.$axios.uploadOne(param_1).then(res => {
        if (res.code == 200) {
          //文件已经存在
          _this.ruleForm.file_url = res.data.url;
          var img = {
            name: res.data.name,
            url: res.data.url
          }
          _this.fileList.push(img);

        } else {

          let param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id')
          };
          this.$axios.getAliJsonCmp(param).then(res => {
            let data = res['data'];
            console.log('aliyun', data);
            let suffix = _this.get_suffix(file.name);
            let autoname = _this.Ymdhis();
            let key = data['dir'];
            let host = data['host'];
            let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
            let request = new FormData();
            request.append('name', file.name);
            request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
            request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
            request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
            request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
            request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
            request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
            request.append('file', file);//需要上传的文件 file
            console.log('aliyun5555', request);
            axios.post(host, request, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
              //请求成功，触发then中的函数
              console.log('upload -res--------', res)
              var fileurl = res.data.filename; //上传完成后的文件oss地址
              var fullurl = host + '/' + fileurl;
              _this.ruleForm.file_url = fullurl;
              var img = {
                name: fileName,
                url: fullurl
              }
              _this.fileList.push(img);
              //更新上传资料
              let upload_params = {
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                name: fileName,
                size: fileSize,
                ext: fileExtension,
                md5: file_md5,
                sha1: file_sha1,
                path: fileurl,
                url: fullurl,
                status: 1,
              };
              console.log('upload---save params', upload_params)
              _this.$axios.uploadSave(upload_params).then(resu => {
                console.log('upload---save', resu)
              });

            })
                .catch(error =>
                    //请求失败，触发catch中的函数 可省略
                    console.log(error)
                )
          });

        }
      });
    },
    async readFileAsBinaryString(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
        reader.readAsBinaryString(file);
      });
    },
    async  calculateMD5(file) {
      return  this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString);
        return CryptoJS.MD5(words).toString();
      });
    },
    async calculateSHA1(file) {
      return  this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString);
        return CryptoJS.SHA1(words).toString();
      });
    },
    get_suffix(filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos != -1) {
        suffix = filename.substring(pos)
      }
      return suffix;
    },
    Ymdhis(){
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth()+1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return ''+year+month+day+hour+minute+second+(Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000);
    },
    // 移除图片
    handleImageRemove(file, fileList) {
      this.fileList = fileList;
      this.imageList = fileList.map(item => item.url || URL.createObjectURL(item.raw));
    },

    // 预览图片
    previewImageHandle(url) {
      this.previewImage = url;
      this.previewVisible = true;
    },

    // 选择位置
    selectLocation() {
      this.tempLocation = this.advancedOptions.location;
      this.showLocationDialog = true;
    },

    // 确认位置选择
    confirmLocation() {
      this.advancedOptions.location = this.tempLocation;
      this.showLocationDialog = false;
      this.$message({ type: 'success', message: '位置已选择' });
    },

    // 选择提醒的人
    selectRemind() {
      this.showRemindDialog = true;
    },

    // 确认提醒选择
    confirmRemind() {
      this.showRemindDialog = false;

      this.$message({ type: 'success', message: '提醒人选已确定' });
    },

    // 生成预览/返回编辑
    generateShare() {
      if (this.showEdit) {
        // 验证内容
        if (!this.editText.trim() && this.imageList.length === 0) {
          this.$message({ type: 'warning', message: '请填写文案或添加图片' });
          return;
        }
        this.contentText = this.editText;
        this.showEdit = false;
      } else {
        this.showEdit = true;
      }
    },

    // 获取文本域光标位置
    getCursorPosition() {
      const textarea = this.$refs.textArea.$el.querySelector('textarea');
      return textarea.selectionStart;
    },

    // 插入表情
    insertEmojiText(emoji) {
      const textarea = this.$refs.textArea.$el.querySelector('textarea');
      const cursorPos = textarea.selectionStart;
      const text = this.editText;

      // 插入表情到光标位置
      this.editText = text.slice(0, cursorPos) + emoji + text.slice(cursorPos);
      this.showEmojiDialog = false;

      // 恢复光标位置
      setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = cursorPos + 1;
        textarea.selectionEnd = cursorPos + 1;
      }, 0);
    },

    // 清空所有内容
    clearAll() {
      this.$confirm('确定清空所有内容吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.editText = '';
        this.contentText = '';
        this.imageList = [];
        this.fileList = [];
        this.advancedOptions.location = '';
        this.advancedOptions.privacy = 'public';
        this.selectedRemindUsers = [];
        localStorage.removeItem('shareDraft');
        this.$message({ type: 'success', message: '已清空所有内容' });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消清空' });
      });
    },

    // 加载默认图片（模拟）
    loadDefaultImages() {
      const defaultImages = [
        'https://picsum.photos/200/200?random=1',
        'https://picsum.photos/200/200?random=2',
        'https://picsum.photos/200/200?random=3'
      ];
      this.imageList = defaultImages;
      this.fileList = defaultImages.map((url, index) => ({
        name: `default${index + 1}.jpg`,
        url: url
      }));
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.share-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-color: #f8f9fa;
}

/* 导航栏 */
.custom-navbar {
  background: white;
  padding: 0;
  margin: 0;
}
.nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 60px;
}
.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

/* 主内容区 */
.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}
.edit-container, .preview-container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

/* 卡片样式 */
.input-card, .upload-card, .options-card {
  margin-bottom: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.card-tip {
  font-size: 12px;
  color: #999;
}

/* 文案输入区 */
.content-input {
  font-size: 16px;
  line-height: 1.6;
}
.input-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f5f5f5;
}
.char-count {
  font-size: 12px;
  color: #999;
}

/* 图片上传区 */
.image-uploader {
  margin-bottom: 20px;
}
.upload-tips {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 12px;
  color: #999;
}
.tip-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 高级选项 */
.option-form {
  padding: 10px 0;
}
.option-input, .option-select {
  width: 100%;
}

/* 预览区域 */
.preview-card {
  margin-bottom: 20px;
}
.share-card {
  padding: 20px;
  background: white;
  border-radius: 8px;
}
.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.username {
  font-size: 16px;
  font-weight: 500;
}
.share-content {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 15px;
  color: #333;
}
.share-images {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.preview-image {
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
}
.preview-tips-card {
  margin-bottom: 20px;
}
.modify-btn {
  width: 100%;
  padding: 10px 0;
}

/* 底部操作栏 */
.action-bar {
  padding: 15px 20px;
  background: white;
  border-top: 1px solid #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.generate-btn {
  padding: 10px 30px;
}

/* 表情弹窗 */
.emoji-content {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 15px;
  padding: 10px;
}
.emoji-item {
  font-size: 24px;
  text-align: center;
  padding: 10px;
  border-radius: 8px;
  background: #f5f5f5;
  cursor: pointer;
  transition: all 0.2s;
}
.emoji-item:hover {
  background: #e8e8e8;
}

/* 弹窗样式 */
.location-input, .remind-select {
  width: 100%;
  margin-bottom: 20px;
}
.dialog-footer {
  text-align: right;
}
</style>